import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { firstValueFrom } from 'rxjs';
import { isJWTValid } from 'src/app/helpers/jwt';
import { ToastService } from 'src/app/services/toast/toast.service';

export const JWTAuthGuard = async (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const toastService = inject(ToastService);
  const translateService = inject(TranslocoService);

  // wait for translation to be loaded
  await translateService.load('en');

  const jwt = route.queryParamMap.get('jwt') ?? undefined;

  if (!jwt) {
    const noJWTProvided = await firstValueFrom(
      translateService.selectTranslate('misc.jwtGuard.noJWTProvided')
    );

    toastService.showError(new Error(noJWTProvided));
    router.navigate(['/']);
    return false;
  }

  if (!isJWTValid(jwt)) {
    const invalidJWT = await firstValueFrom(
      translateService.selectTranslate('misc.jwtGuard.invalidJWT')
    );

    toastService.showError(new Error(invalidJWT));
    router.navigate(['/']);
    return false;
  }

  return true;
};
